var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "root" }, [
    _c("div", { staticClass: "center" }, [
      _c("h1", [_vm._v(_vm._s(_vm.$t("changeEmailPage.title")))]),
      _c("p", [
        _vm._v(" " + _vm._s(_vm.$t("changeEmailPage.description"))),
        _c("br"),
        _vm._v(" " + _vm._s(_vm.$t("changeEmailPage.descriptionNote")) + " "),
      ]),
      _c(
        "div",
        { staticClass: "left" },
        [
          _c("text-field", {
            staticClass: "text-field",
            attrs: {
              type: "email",
              label: _vm.$t("changeEmailPage.currentEmailLabel"),
              placeholder: _vm.$t("changeEmailPage.currentEmailPlaceholder"),
              name: "email-old",
              disabled: "",
            },
            model: {
              value: _vm.oldMailAddress,
              callback: function ($$v) {
                _vm.oldMailAddress = $$v
              },
              expression: "oldMailAddress",
            },
          }),
          _c("text-field", {
            staticClass: "text-field",
            attrs: {
              type: "email",
              label: _vm.$t("changeEmailPage.newEmailLabel"),
              placeholder: _vm.$t("changeEmailPage.newEmailPlaceholder"),
              name: "email-new",
            },
            model: {
              value: _vm.newMailAddress,
              callback: function ($$v) {
                _vm.newMailAddress = $$v
              },
              expression: "newMailAddress",
            },
          }),
        ],
        1
      ),
      _vm.message
        ? _c("div", { staticClass: "info" }, [_vm._v(_vm._s(_vm.message))])
        : _vm._e(),
      _c(
        "button",
        {
          staticClass: "button",
          attrs: {
            disabled:
              _vm.processing || !_vm.oldMailAddress || !_vm.newMailAddress,
          },
          on: { click: _vm.submit },
        },
        [_vm._v(" " + _vm._s(_vm.$t("changeEmailPage.submitButton")) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }